import script from "./DetailField.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailField.vue?vue&type=script&setup=true&lang=js"

import "./DetailField.vue?vue&type=style&index=0&id=28638866&scoped=true&lang=css"

import exportComponent from "/home/buddymetal/actions-runner/_work/candidate/candidate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28638866"]])

export default __exports__